
import 'core-js';





export default function loadPolyfills() {
    const fillIntl = () => new Promise((resolve) => {
        if (window.Intl) return resolve();

        require.ensure([
            'intl',
            'intl/locale-data/jsonp/en.js'
        ], (require) => {
            require('intl');
            
            require('intl/locale-data/jsonp/en.js');
            resolve();
        }, 'Intl');
    });

    
    const fillIntlDateTimeFormatTimezone = () => new Promise((resolve) => {
        try {
            new Intl.DateTimeFormat('en', {
                timeZone: 'America/Los_Angeles',
                timeZoneName: 'long'
            }).format();
            return resolve();
        } catch (error) {
            require.ensure(['date-time-format-timezone'], (require) => {
                require('date-time-format-timezone');
                return resolve();
            }, 'DateTimeFormatTimezone');
        }
    });

    const fillUrlSearchParams = () => new Promise((resolve) => {
        if (window.URLSearchParams) return resolve();

        require.ensure(['url-search-params'], (require) => {
            window.URLSearchParams = require('url-search-params');
            return resolve();
        }, 'URLSearchParams');
    });

    const fillRequestAnimationFrame = () => new Promise((resolve) => {
        if (window.requestAnimationFrame) return resolve();

        require.ensure(['raf'], (require) => {
            window.requestAnimationFrame = require('raf').polyfill();
            resolve();
        }, 'requestAnimationFrame');
    });

    return Promise.all([
        fillIntl(),
        fillIntlDateTimeFormatTimezone(),
        fillUrlSearchParams(),
        fillRequestAnimationFrame()
    ]);
}
